// Generated by tools/gen-validator.ts from spec/retrowser.schema.json. Do not edit.
// @ts-nocheck
"use strict";
export const validate = validate20;
export default validate20;
const schema31 = {"$schema":"https://json-schema.org/draft/2020-12/schema","$id":"https://retrowser.app/spec/retrowser.schema.json","title":"retrowser.json (v1)","description":"Manifest of a game build that retrowser.app can load. See retrowser-v1.md.","type":"object","additionalProperties":false,"required":["retrowser","id","title","platform","rom","files","module","video"],"properties":{"$schema":{"type":"string"},"retrowser":{"const":1},"id":{"description":"Stable game id. Saves are keyed by it, so it must not change between builds.","type":"string","pattern":"^[a-z0-9][a-z0-9-]{0,63}$"},"title":{"type":"string","minLength":1,"maxLength":120},"platform":{"enum":["n64","gba"]},"rom":{"type":"object","additionalProperties":false,"required":["accept"],"properties":{"accept":{"type":"array","minItems":1,"maxItems":8,"uniqueItems":true,"items":{"type":"string","pattern":"^\\.[a-z0-9]{1,8}$"}},"sha1":{"description":"Fingerprints of the expected ROM (N64: of the big-endian .z64 form). Used only to warn about a wrong ROM. Empty or absent: any ROM is accepted without warning.","type":"array","maxItems":16,"uniqueItems":true,"items":{"$ref":"#/$defs/sha1"}},"byteswap":{"enum":["auto","none"],"default":"auto"},"maxSize":{"type":"integer","minimum":1,"maximum":268435456}}},"files":{"type":"object","additionalProperties":false,"required":["wasm"],"properties":{"wasm":{"$ref":"#/$defs/file"},"js":{"$ref":"#/$defs/file"},"data":{"type":"array","maxItems":64,"items":{"$ref":"#/$defs/file"}}}},"module":{"type":"object","additionalProperties":false,"required":["loop"],"properties":{"factory":{"type":"string","pattern":"^[A-Za-z_$][A-Za-z0-9_$]{0,63}$"},"loop":{"enum":["frame","asyncify","mainloop"]}}},"video":{"enum":["framebuffer","webgl"]},"hz":{"type":"number","minimum":1,"maximum":240,"default":60},"memory":{"type":"object","additionalProperties":false,"properties":{"initialMB":{"type":"integer","minimum":1,"maximum":4096},"maximumMB":{"type":"integer","minimum":1,"maximum":16384},"memory64":{"type":"boolean","default":false}}},"save":{"type":"object","additionalProperties":false,"required":["kind"],"properties":{"kind":{"enum":["none","eeprom","sram","flash","controllerpak"]},"size":{"type":"integer","minimum":0,"maximum":1048576}}},"controls":{"type":"object","additionalProperties":false,"properties":{"extra":{"type":"array","maxItems":16,"items":{"type":"object","additionalProperties":false,"required":["bit","label"],"properties":{"bit":{"type":"integer","minimum":16,"maximum":31},"label":{"$ref":"#/$defs/label"}}}}}},"options":{"type":"array","maxItems":64,"items":{"type":"object","additionalProperties":false,"required":["id","label","type"],"properties":{"id":{"type":"integer","minimum":0,"maximum":65535},"label":{"$ref":"#/$defs/label"},"type":{"enum":["bool","int","enum"]},"default":{"type":"integer"},"min":{"type":"integer"},"max":{"type":"integer"},"choices":{"type":"array","maxItems":32,"items":{"type":"object","additionalProperties":false,"required":["value","label"],"properties":{"value":{"type":"integer"},"label":{"$ref":"#/$defs/label"}}}}}}},"net":{"type":"object","description":"[1.2] Online play. players > 1 opts in and requires the net exports (spec §4.12).","additionalProperties":false,"properties":{"players":{"type":"integer","minimum":1,"maximum":4,"description":"Most players in one session (2..4 plays online; 1 = offline only)."},"model":{"enum":["lockstep","link"],"description":"lockstep (default): every peer reboots from power-on with the room host's options and save. link: the session starts while each player keeps playing their own game and save (e.g. a link cable)."}}},"shares":{"type":"object","additionalProperties":false,"properties":{"provides":{"type":"array","maxItems":16,"items":{"$ref":"#/$defs/shareKind"}},"consumes":{"type":"array","maxItems":16,"items":{"$ref":"#/$defs/shareKind"}}}},"license":{"type":"string","maxLength":200},"source":{"type":"string","maxLength":300,"pattern":"^https://"},"fileInputs":{"description":"v1.1: files the player can hand to the game (e.g. a recording to replay). The host offers a picker per entry and calls rtw_file_buffer / rtw_file_ready.","type":"array","maxItems":8,"items":{"type":"object","additionalProperties":false,"required":["id","label","accept"],"properties":{"id":{"type":"integer","minimum":1,"maximum":255},"label":{"$ref":"#/$defs/label"},"accept":{"type":"array","minItems":1,"maxItems":8,"uniqueItems":true,"items":{"type":"string","pattern":"^\\.[a-z0-9]{1,8}$"}},"maxSize":{"type":"integer","minimum":1,"maximum":67108864}}}}},"$defs":{"sha1":{"type":"string","pattern":"^[0-9a-f]{40}$"},"sha256":{"type":"string","pattern":"^[0-9a-f]{64}$"},"label":{"type":"string","minLength":1,"maxLength":40},"shareKind":{"type":"string","pattern":"^[a-z0-9][a-z0-9-]{0,63}$"},"path":{"description":"Relative POSIX path from the manifest's directory. No leading slash, no '.' or '..' segments.","type":"string","maxLength":256,"pattern":"^(?!/)(?!.*(?:^|/)\\.\\.?(?:/|$))(?!.*//)[A-Za-z0-9._/-]+$"},"file":{"type":"object","additionalProperties":false,"required":["path","sha256","size"],"properties":{"path":{"$ref":"#/$defs/path"},"sha256":{"$ref":"#/$defs/sha256"},"size":{"description":"Exact length in bytes. The host shows the total before downloading and rejects a file of any other length before hashing it.","type":"integer","minimum":0,"maximum":67108864}}}}};
const schema32 = {"type":"string","pattern":"^[0-9a-f]{40}$"};
const schema36 = {"type":"string","minLength":1,"maxLength":40};
const schema39 = {"type":"string","pattern":"^[a-z0-9][a-z0-9-]{0,63}$"};
const func1 = Object.prototype.hasOwnProperty;
const func2 = function(s) { return Array.from(s).length; };
const func0 = function(a, b) { return JSON.stringify(a) === JSON.stringify(b); };
const pattern4 = new RegExp("^[a-z0-9][a-z0-9-]{0,63}$", "u");
const pattern5 = new RegExp("^\\.[a-z0-9]{1,8}$", "u");
const pattern6 = new RegExp("^[0-9a-f]{40}$", "u");
const pattern9 = new RegExp("^[A-Za-z_$][A-Za-z0-9_$]{0,63}$", "u");
const pattern12 = new RegExp("^https://", "u");
const schema33 = {"type":"object","additionalProperties":false,"required":["path","sha256","size"],"properties":{"path":{"$ref":"#/$defs/path"},"sha256":{"$ref":"#/$defs/sha256"},"size":{"description":"Exact length in bytes. The host shows the total before downloading and rejects a file of any other length before hashing it.","type":"integer","minimum":0,"maximum":67108864}}};
const schema34 = {"description":"Relative POSIX path from the manifest's directory. No leading slash, no '.' or '..' segments.","type":"string","maxLength":256,"pattern":"^(?!/)(?!.*(?:^|/)\\.\\.?(?:/|$))(?!.*//)[A-Za-z0-9._/-]+$"};
const schema35 = {"type":"string","pattern":"^[0-9a-f]{64}$"};
const pattern7 = new RegExp("^(?!/)(?!.*(?:^|/)\\.\\.?(?:/|$))(?!.*//)[A-Za-z0-9._/-]+$", "u");
const pattern8 = new RegExp("^[0-9a-f]{64}$", "u");

function validate21(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
let vErrors = null;
let errors = 0;
const evaluated0 = validate21.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.path === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "path"},message:"must have required property '"+"path"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.sha256 === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "sha256"},message:"must have required property '"+"sha256"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.size === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "size"},message:"must have required property '"+"size"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
for(const key0 in data){
if(!(((key0 === "path") || (key0 === "sha256")) || (key0 === "size"))){
const err3 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
}
if(data.path !== undefined){
let data0 = data.path;
if(typeof data0 === "string"){
if(func2(data0) > 256){
const err4 = {instancePath:instancePath+"/path",schemaPath:"#/$defs/path/maxLength",keyword:"maxLength",params:{limit: 256},message:"must NOT have more than 256 characters"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(!pattern7.test(data0)){
const err5 = {instancePath:instancePath+"/path",schemaPath:"#/$defs/path/pattern",keyword:"pattern",params:{pattern: "^(?!/)(?!.*(?:^|/)\\.\\.?(?:/|$))(?!.*//)[A-Za-z0-9._/-]+$"},message:"must match pattern \""+"^(?!/)(?!.*(?:^|/)\\.\\.?(?:/|$))(?!.*//)[A-Za-z0-9._/-]+$"+"\""};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
}
else {
const err6 = {instancePath:instancePath+"/path",schemaPath:"#/$defs/path/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.sha256 !== undefined){
let data1 = data.sha256;
if(typeof data1 === "string"){
if(!pattern8.test(data1)){
const err7 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/sha256/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{64}$"},message:"must match pattern \""+"^[0-9a-f]{64}$"+"\""};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/sha256",schemaPath:"#/$defs/sha256/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.size !== undefined){
let data2 = data.size;
if(!(((typeof data2 == "number") && (!(data2 % 1) && !isNaN(data2))) && (isFinite(data2)))){
const err9 = {instancePath:instancePath+"/size",schemaPath:"#/properties/size/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
if((typeof data2 == "number") && (isFinite(data2))){
if(data2 > 67108864 || isNaN(data2)){
const err10 = {instancePath:instancePath+"/size",schemaPath:"#/properties/size/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
if(data2 < 0 || isNaN(data2)){
const err11 = {instancePath:instancePath+"/size",schemaPath:"#/properties/size/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
}
}
else {
const err12 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
validate21.errors = vErrors;
return errors === 0;
}
validate21.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};


function validate20(data, {instancePath="", parentData, parentDataProperty, rootData=data, dynamicAnchors={}}={}){
/*# sourceURL="https://retrowser.app/spec/retrowser.schema.json" */;
let vErrors = null;
let errors = 0;
const evaluated0 = validate20.evaluated;
if(evaluated0.dynamicProps){
evaluated0.props = undefined;
}
if(evaluated0.dynamicItems){
evaluated0.items = undefined;
}
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.retrowser === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "retrowser"},message:"must have required property '"+"retrowser"+"'"};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.id === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.title === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "title"},message:"must have required property '"+"title"+"'"};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.platform === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "platform"},message:"must have required property '"+"platform"+"'"};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.rom === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "rom"},message:"must have required property '"+"rom"+"'"};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.files === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "files"},message:"must have required property '"+"files"+"'"};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.module === undefined){
const err6 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "module"},message:"must have required property '"+"module"+"'"};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
if(data.video === undefined){
const err7 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "video"},message:"must have required property '"+"video"+"'"};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
for(const key0 in data){
if(!(func1.call(schema31.properties, key0))){
const err8 = {instancePath,schemaPath:"#/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key0},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.$schema !== undefined){
if(typeof data.$schema !== "string"){
const err9 = {instancePath:instancePath+"/$schema",schemaPath:"#/properties/%24schema/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
if(data.retrowser !== undefined){
if(1 !== data.retrowser){
const err10 = {instancePath:instancePath+"/retrowser",schemaPath:"#/properties/retrowser/const",keyword:"const",params:{allowedValue: 1},message:"must be equal to constant"};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.id !== undefined){
let data2 = data.id;
if(typeof data2 === "string"){
if(!pattern4.test(data2)){
const err11 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]{0,63}$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]{0,63}$"+"\""};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
}
else {
const err12 = {instancePath:instancePath+"/id",schemaPath:"#/properties/id/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.title !== undefined){
let data3 = data.title;
if(typeof data3 === "string"){
if(func2(data3) > 120){
const err13 = {instancePath:instancePath+"/title",schemaPath:"#/properties/title/maxLength",keyword:"maxLength",params:{limit: 120},message:"must NOT have more than 120 characters"};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(func2(data3) < 1){
const err14 = {instancePath:instancePath+"/title",schemaPath:"#/properties/title/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
else {
const err15 = {instancePath:instancePath+"/title",schemaPath:"#/properties/title/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.platform !== undefined){
let data4 = data.platform;
if(!((data4 === "n64") || (data4 === "gba"))){
const err16 = {instancePath:instancePath+"/platform",schemaPath:"#/properties/platform/enum",keyword:"enum",params:{allowedValues: schema31.properties.platform.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
if(data.rom !== undefined){
let data5 = data.rom;
if(data5 && typeof data5 == "object" && !Array.isArray(data5)){
if(data5.accept === undefined){
const err17 = {instancePath:instancePath+"/rom",schemaPath:"#/properties/rom/required",keyword:"required",params:{missingProperty: "accept"},message:"must have required property '"+"accept"+"'"};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
for(const key1 in data5){
if(!((((key1 === "accept") || (key1 === "sha1")) || (key1 === "byteswap")) || (key1 === "maxSize"))){
const err18 = {instancePath:instancePath+"/rom",schemaPath:"#/properties/rom/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key1},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err18];
}
else {
vErrors.push(err18);
}
errors++;
}
}
if(data5.accept !== undefined){
let data6 = data5.accept;
if(Array.isArray(data6)){
if(data6.length > 8){
const err19 = {instancePath:instancePath+"/rom/accept",schemaPath:"#/properties/rom/properties/accept/maxItems",keyword:"maxItems",params:{limit: 8},message:"must NOT have more than 8 items"};
if(vErrors === null){
vErrors = [err19];
}
else {
vErrors.push(err19);
}
errors++;
}
if(data6.length < 1){
const err20 = {instancePath:instancePath+"/rom/accept",schemaPath:"#/properties/rom/properties/accept/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err20];
}
else {
vErrors.push(err20);
}
errors++;
}
const len0 = data6.length;
for(let i0=0; i0<len0; i0++){
let data7 = data6[i0];
if(typeof data7 === "string"){
if(!pattern5.test(data7)){
const err21 = {instancePath:instancePath+"/rom/accept/" + i0,schemaPath:"#/properties/rom/properties/accept/items/pattern",keyword:"pattern",params:{pattern: "^\\.[a-z0-9]{1,8}$"},message:"must match pattern \""+"^\\.[a-z0-9]{1,8}$"+"\""};
if(vErrors === null){
vErrors = [err21];
}
else {
vErrors.push(err21);
}
errors++;
}
}
else {
const err22 = {instancePath:instancePath+"/rom/accept/" + i0,schemaPath:"#/properties/rom/properties/accept/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err22];
}
else {
vErrors.push(err22);
}
errors++;
}
}
let i1 = data6.length;
let j0;
if(i1 > 1){
const indices0 = {};
for(;i1--;){
let item0 = data6[i1];
if(typeof item0 !== "string"){
continue;
}
if(typeof indices0[item0] == "number"){
j0 = indices0[item0];
const err23 = {instancePath:instancePath+"/rom/accept",schemaPath:"#/properties/rom/properties/accept/uniqueItems",keyword:"uniqueItems",params:{i: i1, j: j0},message:"must NOT have duplicate items (items ## "+j0+" and "+i1+" are identical)"};
if(vErrors === null){
vErrors = [err23];
}
else {
vErrors.push(err23);
}
errors++;
break;
}
indices0[item0] = i1;
}
}
}
else {
const err24 = {instancePath:instancePath+"/rom/accept",schemaPath:"#/properties/rom/properties/accept/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err24];
}
else {
vErrors.push(err24);
}
errors++;
}
}
if(data5.sha1 !== undefined){
let data8 = data5.sha1;
if(Array.isArray(data8)){
if(data8.length > 16){
const err25 = {instancePath:instancePath+"/rom/sha1",schemaPath:"#/properties/rom/properties/sha1/maxItems",keyword:"maxItems",params:{limit: 16},message:"must NOT have more than 16 items"};
if(vErrors === null){
vErrors = [err25];
}
else {
vErrors.push(err25);
}
errors++;
}
const len1 = data8.length;
for(let i2=0; i2<len1; i2++){
let data9 = data8[i2];
if(typeof data9 === "string"){
if(!pattern6.test(data9)){
const err26 = {instancePath:instancePath+"/rom/sha1/" + i2,schemaPath:"#/$defs/sha1/pattern",keyword:"pattern",params:{pattern: "^[0-9a-f]{40}$"},message:"must match pattern \""+"^[0-9a-f]{40}$"+"\""};
if(vErrors === null){
vErrors = [err26];
}
else {
vErrors.push(err26);
}
errors++;
}
}
else {
const err27 = {instancePath:instancePath+"/rom/sha1/" + i2,schemaPath:"#/$defs/sha1/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err27];
}
else {
vErrors.push(err27);
}
errors++;
}
}
let i3 = data8.length;
let j1;
if(i3 > 1){
outer0:
for(;i3--;){
for(j1 = i3; j1--;){
if(func0(data8[i3], data8[j1])){
const err28 = {instancePath:instancePath+"/rom/sha1",schemaPath:"#/properties/rom/properties/sha1/uniqueItems",keyword:"uniqueItems",params:{i: i3, j: j1},message:"must NOT have duplicate items (items ## "+j1+" and "+i3+" are identical)"};
if(vErrors === null){
vErrors = [err28];
}
else {
vErrors.push(err28);
}
errors++;
break outer0;
}
}
}
}
}
else {
const err29 = {instancePath:instancePath+"/rom/sha1",schemaPath:"#/properties/rom/properties/sha1/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err29];
}
else {
vErrors.push(err29);
}
errors++;
}
}
if(data5.byteswap !== undefined){
let data10 = data5.byteswap;
if(!((data10 === "auto") || (data10 === "none"))){
const err30 = {instancePath:instancePath+"/rom/byteswap",schemaPath:"#/properties/rom/properties/byteswap/enum",keyword:"enum",params:{allowedValues: schema31.properties.rom.properties.byteswap.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err30];
}
else {
vErrors.push(err30);
}
errors++;
}
}
if(data5.maxSize !== undefined){
let data11 = data5.maxSize;
if(!(((typeof data11 == "number") && (!(data11 % 1) && !isNaN(data11))) && (isFinite(data11)))){
const err31 = {instancePath:instancePath+"/rom/maxSize",schemaPath:"#/properties/rom/properties/maxSize/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err31];
}
else {
vErrors.push(err31);
}
errors++;
}
if((typeof data11 == "number") && (isFinite(data11))){
if(data11 > 268435456 || isNaN(data11)){
const err32 = {instancePath:instancePath+"/rom/maxSize",schemaPath:"#/properties/rom/properties/maxSize/maximum",keyword:"maximum",params:{comparison: "<=", limit: 268435456},message:"must be <= 268435456"};
if(vErrors === null){
vErrors = [err32];
}
else {
vErrors.push(err32);
}
errors++;
}
if(data11 < 1 || isNaN(data11)){
const err33 = {instancePath:instancePath+"/rom/maxSize",schemaPath:"#/properties/rom/properties/maxSize/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err33];
}
else {
vErrors.push(err33);
}
errors++;
}
}
}
}
else {
const err34 = {instancePath:instancePath+"/rom",schemaPath:"#/properties/rom/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err34];
}
else {
vErrors.push(err34);
}
errors++;
}
}
if(data.files !== undefined){
let data12 = data.files;
if(data12 && typeof data12 == "object" && !Array.isArray(data12)){
if(data12.wasm === undefined){
const err35 = {instancePath:instancePath+"/files",schemaPath:"#/properties/files/required",keyword:"required",params:{missingProperty: "wasm"},message:"must have required property '"+"wasm"+"'"};
if(vErrors === null){
vErrors = [err35];
}
else {
vErrors.push(err35);
}
errors++;
}
for(const key2 in data12){
if(!(((key2 === "wasm") || (key2 === "js")) || (key2 === "data"))){
const err36 = {instancePath:instancePath+"/files",schemaPath:"#/properties/files/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key2},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err36];
}
else {
vErrors.push(err36);
}
errors++;
}
}
if(data12.wasm !== undefined){
if(!(validate21(data12.wasm, {instancePath:instancePath+"/files/wasm",parentData:data12,parentDataProperty:"wasm",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
if(data12.js !== undefined){
if(!(validate21(data12.js, {instancePath:instancePath+"/files/js",parentData:data12,parentDataProperty:"js",rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
if(data12.data !== undefined){
let data15 = data12.data;
if(Array.isArray(data15)){
if(data15.length > 64){
const err37 = {instancePath:instancePath+"/files/data",schemaPath:"#/properties/files/properties/data/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err37];
}
else {
vErrors.push(err37);
}
errors++;
}
const len2 = data15.length;
for(let i4=0; i4<len2; i4++){
if(!(validate21(data15[i4], {instancePath:instancePath+"/files/data/" + i4,parentData:data15,parentDataProperty:i4,rootData,dynamicAnchors}))){
vErrors = vErrors === null ? validate21.errors : vErrors.concat(validate21.errors);
errors = vErrors.length;
}
}
}
else {
const err38 = {instancePath:instancePath+"/files/data",schemaPath:"#/properties/files/properties/data/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err38];
}
else {
vErrors.push(err38);
}
errors++;
}
}
}
else {
const err39 = {instancePath:instancePath+"/files",schemaPath:"#/properties/files/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err39];
}
else {
vErrors.push(err39);
}
errors++;
}
}
if(data.module !== undefined){
let data17 = data.module;
if(data17 && typeof data17 == "object" && !Array.isArray(data17)){
if(data17.loop === undefined){
const err40 = {instancePath:instancePath+"/module",schemaPath:"#/properties/module/required",keyword:"required",params:{missingProperty: "loop"},message:"must have required property '"+"loop"+"'"};
if(vErrors === null){
vErrors = [err40];
}
else {
vErrors.push(err40);
}
errors++;
}
for(const key3 in data17){
if(!((key3 === "factory") || (key3 === "loop"))){
const err41 = {instancePath:instancePath+"/module",schemaPath:"#/properties/module/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key3},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err41];
}
else {
vErrors.push(err41);
}
errors++;
}
}
if(data17.factory !== undefined){
let data18 = data17.factory;
if(typeof data18 === "string"){
if(!pattern9.test(data18)){
const err42 = {instancePath:instancePath+"/module/factory",schemaPath:"#/properties/module/properties/factory/pattern",keyword:"pattern",params:{pattern: "^[A-Za-z_$][A-Za-z0-9_$]{0,63}$"},message:"must match pattern \""+"^[A-Za-z_$][A-Za-z0-9_$]{0,63}$"+"\""};
if(vErrors === null){
vErrors = [err42];
}
else {
vErrors.push(err42);
}
errors++;
}
}
else {
const err43 = {instancePath:instancePath+"/module/factory",schemaPath:"#/properties/module/properties/factory/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err43];
}
else {
vErrors.push(err43);
}
errors++;
}
}
if(data17.loop !== undefined){
let data19 = data17.loop;
if(!(((data19 === "frame") || (data19 === "asyncify")) || (data19 === "mainloop"))){
const err44 = {instancePath:instancePath+"/module/loop",schemaPath:"#/properties/module/properties/loop/enum",keyword:"enum",params:{allowedValues: schema31.properties.module.properties.loop.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err44];
}
else {
vErrors.push(err44);
}
errors++;
}
}
}
else {
const err45 = {instancePath:instancePath+"/module",schemaPath:"#/properties/module/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err45];
}
else {
vErrors.push(err45);
}
errors++;
}
}
if(data.video !== undefined){
let data20 = data.video;
if(!((data20 === "framebuffer") || (data20 === "webgl"))){
const err46 = {instancePath:instancePath+"/video",schemaPath:"#/properties/video/enum",keyword:"enum",params:{allowedValues: schema31.properties.video.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err46];
}
else {
vErrors.push(err46);
}
errors++;
}
}
if(data.hz !== undefined){
let data21 = data.hz;
if((typeof data21 == "number") && (isFinite(data21))){
if(data21 > 240 || isNaN(data21)){
const err47 = {instancePath:instancePath+"/hz",schemaPath:"#/properties/hz/maximum",keyword:"maximum",params:{comparison: "<=", limit: 240},message:"must be <= 240"};
if(vErrors === null){
vErrors = [err47];
}
else {
vErrors.push(err47);
}
errors++;
}
if(data21 < 1 || isNaN(data21)){
const err48 = {instancePath:instancePath+"/hz",schemaPath:"#/properties/hz/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err48];
}
else {
vErrors.push(err48);
}
errors++;
}
}
else {
const err49 = {instancePath:instancePath+"/hz",schemaPath:"#/properties/hz/type",keyword:"type",params:{type: "number"},message:"must be number"};
if(vErrors === null){
vErrors = [err49];
}
else {
vErrors.push(err49);
}
errors++;
}
}
if(data.memory !== undefined){
let data22 = data.memory;
if(data22 && typeof data22 == "object" && !Array.isArray(data22)){
for(const key4 in data22){
if(!(((key4 === "initialMB") || (key4 === "maximumMB")) || (key4 === "memory64"))){
const err50 = {instancePath:instancePath+"/memory",schemaPath:"#/properties/memory/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key4},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err50];
}
else {
vErrors.push(err50);
}
errors++;
}
}
if(data22.initialMB !== undefined){
let data23 = data22.initialMB;
if(!(((typeof data23 == "number") && (!(data23 % 1) && !isNaN(data23))) && (isFinite(data23)))){
const err51 = {instancePath:instancePath+"/memory/initialMB",schemaPath:"#/properties/memory/properties/initialMB/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err51];
}
else {
vErrors.push(err51);
}
errors++;
}
if((typeof data23 == "number") && (isFinite(data23))){
if(data23 > 4096 || isNaN(data23)){
const err52 = {instancePath:instancePath+"/memory/initialMB",schemaPath:"#/properties/memory/properties/initialMB/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4096},message:"must be <= 4096"};
if(vErrors === null){
vErrors = [err52];
}
else {
vErrors.push(err52);
}
errors++;
}
if(data23 < 1 || isNaN(data23)){
const err53 = {instancePath:instancePath+"/memory/initialMB",schemaPath:"#/properties/memory/properties/initialMB/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err53];
}
else {
vErrors.push(err53);
}
errors++;
}
}
}
if(data22.maximumMB !== undefined){
let data24 = data22.maximumMB;
if(!(((typeof data24 == "number") && (!(data24 % 1) && !isNaN(data24))) && (isFinite(data24)))){
const err54 = {instancePath:instancePath+"/memory/maximumMB",schemaPath:"#/properties/memory/properties/maximumMB/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err54];
}
else {
vErrors.push(err54);
}
errors++;
}
if((typeof data24 == "number") && (isFinite(data24))){
if(data24 > 16384 || isNaN(data24)){
const err55 = {instancePath:instancePath+"/memory/maximumMB",schemaPath:"#/properties/memory/properties/maximumMB/maximum",keyword:"maximum",params:{comparison: "<=", limit: 16384},message:"must be <= 16384"};
if(vErrors === null){
vErrors = [err55];
}
else {
vErrors.push(err55);
}
errors++;
}
if(data24 < 1 || isNaN(data24)){
const err56 = {instancePath:instancePath+"/memory/maximumMB",schemaPath:"#/properties/memory/properties/maximumMB/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err56];
}
else {
vErrors.push(err56);
}
errors++;
}
}
}
if(data22.memory64 !== undefined){
if(typeof data22.memory64 !== "boolean"){
const err57 = {instancePath:instancePath+"/memory/memory64",schemaPath:"#/properties/memory/properties/memory64/type",keyword:"type",params:{type: "boolean"},message:"must be boolean"};
if(vErrors === null){
vErrors = [err57];
}
else {
vErrors.push(err57);
}
errors++;
}
}
}
else {
const err58 = {instancePath:instancePath+"/memory",schemaPath:"#/properties/memory/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err58];
}
else {
vErrors.push(err58);
}
errors++;
}
}
if(data.save !== undefined){
let data26 = data.save;
if(data26 && typeof data26 == "object" && !Array.isArray(data26)){
if(data26.kind === undefined){
const err59 = {instancePath:instancePath+"/save",schemaPath:"#/properties/save/required",keyword:"required",params:{missingProperty: "kind"},message:"must have required property '"+"kind"+"'"};
if(vErrors === null){
vErrors = [err59];
}
else {
vErrors.push(err59);
}
errors++;
}
for(const key5 in data26){
if(!((key5 === "kind") || (key5 === "size"))){
const err60 = {instancePath:instancePath+"/save",schemaPath:"#/properties/save/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key5},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err60];
}
else {
vErrors.push(err60);
}
errors++;
}
}
if(data26.kind !== undefined){
let data27 = data26.kind;
if(!(((((data27 === "none") || (data27 === "eeprom")) || (data27 === "sram")) || (data27 === "flash")) || (data27 === "controllerpak"))){
const err61 = {instancePath:instancePath+"/save/kind",schemaPath:"#/properties/save/properties/kind/enum",keyword:"enum",params:{allowedValues: schema31.properties.save.properties.kind.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err61];
}
else {
vErrors.push(err61);
}
errors++;
}
}
if(data26.size !== undefined){
let data28 = data26.size;
if(!(((typeof data28 == "number") && (!(data28 % 1) && !isNaN(data28))) && (isFinite(data28)))){
const err62 = {instancePath:instancePath+"/save/size",schemaPath:"#/properties/save/properties/size/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err62];
}
else {
vErrors.push(err62);
}
errors++;
}
if((typeof data28 == "number") && (isFinite(data28))){
if(data28 > 1048576 || isNaN(data28)){
const err63 = {instancePath:instancePath+"/save/size",schemaPath:"#/properties/save/properties/size/maximum",keyword:"maximum",params:{comparison: "<=", limit: 1048576},message:"must be <= 1048576"};
if(vErrors === null){
vErrors = [err63];
}
else {
vErrors.push(err63);
}
errors++;
}
if(data28 < 0 || isNaN(data28)){
const err64 = {instancePath:instancePath+"/save/size",schemaPath:"#/properties/save/properties/size/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err64];
}
else {
vErrors.push(err64);
}
errors++;
}
}
}
}
else {
const err65 = {instancePath:instancePath+"/save",schemaPath:"#/properties/save/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err65];
}
else {
vErrors.push(err65);
}
errors++;
}
}
if(data.controls !== undefined){
let data29 = data.controls;
if(data29 && typeof data29 == "object" && !Array.isArray(data29)){
for(const key6 in data29){
if(!(key6 === "extra")){
const err66 = {instancePath:instancePath+"/controls",schemaPath:"#/properties/controls/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key6},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err66];
}
else {
vErrors.push(err66);
}
errors++;
}
}
if(data29.extra !== undefined){
let data30 = data29.extra;
if(Array.isArray(data30)){
if(data30.length > 16){
const err67 = {instancePath:instancePath+"/controls/extra",schemaPath:"#/properties/controls/properties/extra/maxItems",keyword:"maxItems",params:{limit: 16},message:"must NOT have more than 16 items"};
if(vErrors === null){
vErrors = [err67];
}
else {
vErrors.push(err67);
}
errors++;
}
const len3 = data30.length;
for(let i5=0; i5<len3; i5++){
let data31 = data30[i5];
if(data31 && typeof data31 == "object" && !Array.isArray(data31)){
if(data31.bit === undefined){
const err68 = {instancePath:instancePath+"/controls/extra/" + i5,schemaPath:"#/properties/controls/properties/extra/items/required",keyword:"required",params:{missingProperty: "bit"},message:"must have required property '"+"bit"+"'"};
if(vErrors === null){
vErrors = [err68];
}
else {
vErrors.push(err68);
}
errors++;
}
if(data31.label === undefined){
const err69 = {instancePath:instancePath+"/controls/extra/" + i5,schemaPath:"#/properties/controls/properties/extra/items/required",keyword:"required",params:{missingProperty: "label"},message:"must have required property '"+"label"+"'"};
if(vErrors === null){
vErrors = [err69];
}
else {
vErrors.push(err69);
}
errors++;
}
for(const key7 in data31){
if(!((key7 === "bit") || (key7 === "label"))){
const err70 = {instancePath:instancePath+"/controls/extra/" + i5,schemaPath:"#/properties/controls/properties/extra/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key7},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err70];
}
else {
vErrors.push(err70);
}
errors++;
}
}
if(data31.bit !== undefined){
let data32 = data31.bit;
if(!(((typeof data32 == "number") && (!(data32 % 1) && !isNaN(data32))) && (isFinite(data32)))){
const err71 = {instancePath:instancePath+"/controls/extra/" + i5+"/bit",schemaPath:"#/properties/controls/properties/extra/items/properties/bit/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err71];
}
else {
vErrors.push(err71);
}
errors++;
}
if((typeof data32 == "number") && (isFinite(data32))){
if(data32 > 31 || isNaN(data32)){
const err72 = {instancePath:instancePath+"/controls/extra/" + i5+"/bit",schemaPath:"#/properties/controls/properties/extra/items/properties/bit/maximum",keyword:"maximum",params:{comparison: "<=", limit: 31},message:"must be <= 31"};
if(vErrors === null){
vErrors = [err72];
}
else {
vErrors.push(err72);
}
errors++;
}
if(data32 < 16 || isNaN(data32)){
const err73 = {instancePath:instancePath+"/controls/extra/" + i5+"/bit",schemaPath:"#/properties/controls/properties/extra/items/properties/bit/minimum",keyword:"minimum",params:{comparison: ">=", limit: 16},message:"must be >= 16"};
if(vErrors === null){
vErrors = [err73];
}
else {
vErrors.push(err73);
}
errors++;
}
}
}
if(data31.label !== undefined){
let data33 = data31.label;
if(typeof data33 === "string"){
if(func2(data33) > 40){
const err74 = {instancePath:instancePath+"/controls/extra/" + i5+"/label",schemaPath:"#/$defs/label/maxLength",keyword:"maxLength",params:{limit: 40},message:"must NOT have more than 40 characters"};
if(vErrors === null){
vErrors = [err74];
}
else {
vErrors.push(err74);
}
errors++;
}
if(func2(data33) < 1){
const err75 = {instancePath:instancePath+"/controls/extra/" + i5+"/label",schemaPath:"#/$defs/label/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err75];
}
else {
vErrors.push(err75);
}
errors++;
}
}
else {
const err76 = {instancePath:instancePath+"/controls/extra/" + i5+"/label",schemaPath:"#/$defs/label/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err76];
}
else {
vErrors.push(err76);
}
errors++;
}
}
}
else {
const err77 = {instancePath:instancePath+"/controls/extra/" + i5,schemaPath:"#/properties/controls/properties/extra/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err77];
}
else {
vErrors.push(err77);
}
errors++;
}
}
}
else {
const err78 = {instancePath:instancePath+"/controls/extra",schemaPath:"#/properties/controls/properties/extra/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err78];
}
else {
vErrors.push(err78);
}
errors++;
}
}
}
else {
const err79 = {instancePath:instancePath+"/controls",schemaPath:"#/properties/controls/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err79];
}
else {
vErrors.push(err79);
}
errors++;
}
}
if(data.options !== undefined){
let data34 = data.options;
if(Array.isArray(data34)){
if(data34.length > 64){
const err80 = {instancePath:instancePath+"/options",schemaPath:"#/properties/options/maxItems",keyword:"maxItems",params:{limit: 64},message:"must NOT have more than 64 items"};
if(vErrors === null){
vErrors = [err80];
}
else {
vErrors.push(err80);
}
errors++;
}
const len4 = data34.length;
for(let i6=0; i6<len4; i6++){
let data35 = data34[i6];
if(data35 && typeof data35 == "object" && !Array.isArray(data35)){
if(data35.id === undefined){
const err81 = {instancePath:instancePath+"/options/" + i6,schemaPath:"#/properties/options/items/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err81];
}
else {
vErrors.push(err81);
}
errors++;
}
if(data35.label === undefined){
const err82 = {instancePath:instancePath+"/options/" + i6,schemaPath:"#/properties/options/items/required",keyword:"required",params:{missingProperty: "label"},message:"must have required property '"+"label"+"'"};
if(vErrors === null){
vErrors = [err82];
}
else {
vErrors.push(err82);
}
errors++;
}
if(data35.type === undefined){
const err83 = {instancePath:instancePath+"/options/" + i6,schemaPath:"#/properties/options/items/required",keyword:"required",params:{missingProperty: "type"},message:"must have required property '"+"type"+"'"};
if(vErrors === null){
vErrors = [err83];
}
else {
vErrors.push(err83);
}
errors++;
}
for(const key8 in data35){
if(!(((((((key8 === "id") || (key8 === "label")) || (key8 === "type")) || (key8 === "default")) || (key8 === "min")) || (key8 === "max")) || (key8 === "choices"))){
const err84 = {instancePath:instancePath+"/options/" + i6,schemaPath:"#/properties/options/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key8},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err84];
}
else {
vErrors.push(err84);
}
errors++;
}
}
if(data35.id !== undefined){
let data36 = data35.id;
if(!(((typeof data36 == "number") && (!(data36 % 1) && !isNaN(data36))) && (isFinite(data36)))){
const err85 = {instancePath:instancePath+"/options/" + i6+"/id",schemaPath:"#/properties/options/items/properties/id/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err85];
}
else {
vErrors.push(err85);
}
errors++;
}
if((typeof data36 == "number") && (isFinite(data36))){
if(data36 > 65535 || isNaN(data36)){
const err86 = {instancePath:instancePath+"/options/" + i6+"/id",schemaPath:"#/properties/options/items/properties/id/maximum",keyword:"maximum",params:{comparison: "<=", limit: 65535},message:"must be <= 65535"};
if(vErrors === null){
vErrors = [err86];
}
else {
vErrors.push(err86);
}
errors++;
}
if(data36 < 0 || isNaN(data36)){
const err87 = {instancePath:instancePath+"/options/" + i6+"/id",schemaPath:"#/properties/options/items/properties/id/minimum",keyword:"minimum",params:{comparison: ">=", limit: 0},message:"must be >= 0"};
if(vErrors === null){
vErrors = [err87];
}
else {
vErrors.push(err87);
}
errors++;
}
}
}
if(data35.label !== undefined){
let data37 = data35.label;
if(typeof data37 === "string"){
if(func2(data37) > 40){
const err88 = {instancePath:instancePath+"/options/" + i6+"/label",schemaPath:"#/$defs/label/maxLength",keyword:"maxLength",params:{limit: 40},message:"must NOT have more than 40 characters"};
if(vErrors === null){
vErrors = [err88];
}
else {
vErrors.push(err88);
}
errors++;
}
if(func2(data37) < 1){
const err89 = {instancePath:instancePath+"/options/" + i6+"/label",schemaPath:"#/$defs/label/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err89];
}
else {
vErrors.push(err89);
}
errors++;
}
}
else {
const err90 = {instancePath:instancePath+"/options/" + i6+"/label",schemaPath:"#/$defs/label/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err90];
}
else {
vErrors.push(err90);
}
errors++;
}
}
if(data35.type !== undefined){
let data38 = data35.type;
if(!(((data38 === "bool") || (data38 === "int")) || (data38 === "enum"))){
const err91 = {instancePath:instancePath+"/options/" + i6+"/type",schemaPath:"#/properties/options/items/properties/type/enum",keyword:"enum",params:{allowedValues: schema31.properties.options.items.properties.type.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err91];
}
else {
vErrors.push(err91);
}
errors++;
}
}
if(data35.default !== undefined){
let data39 = data35.default;
if(!(((typeof data39 == "number") && (!(data39 % 1) && !isNaN(data39))) && (isFinite(data39)))){
const err92 = {instancePath:instancePath+"/options/" + i6+"/default",schemaPath:"#/properties/options/items/properties/default/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err92];
}
else {
vErrors.push(err92);
}
errors++;
}
}
if(data35.min !== undefined){
let data40 = data35.min;
if(!(((typeof data40 == "number") && (!(data40 % 1) && !isNaN(data40))) && (isFinite(data40)))){
const err93 = {instancePath:instancePath+"/options/" + i6+"/min",schemaPath:"#/properties/options/items/properties/min/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err93];
}
else {
vErrors.push(err93);
}
errors++;
}
}
if(data35.max !== undefined){
let data41 = data35.max;
if(!(((typeof data41 == "number") && (!(data41 % 1) && !isNaN(data41))) && (isFinite(data41)))){
const err94 = {instancePath:instancePath+"/options/" + i6+"/max",schemaPath:"#/properties/options/items/properties/max/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err94];
}
else {
vErrors.push(err94);
}
errors++;
}
}
if(data35.choices !== undefined){
let data42 = data35.choices;
if(Array.isArray(data42)){
if(data42.length > 32){
const err95 = {instancePath:instancePath+"/options/" + i6+"/choices",schemaPath:"#/properties/options/items/properties/choices/maxItems",keyword:"maxItems",params:{limit: 32},message:"must NOT have more than 32 items"};
if(vErrors === null){
vErrors = [err95];
}
else {
vErrors.push(err95);
}
errors++;
}
const len5 = data42.length;
for(let i7=0; i7<len5; i7++){
let data43 = data42[i7];
if(data43 && typeof data43 == "object" && !Array.isArray(data43)){
if(data43.value === undefined){
const err96 = {instancePath:instancePath+"/options/" + i6+"/choices/" + i7,schemaPath:"#/properties/options/items/properties/choices/items/required",keyword:"required",params:{missingProperty: "value"},message:"must have required property '"+"value"+"'"};
if(vErrors === null){
vErrors = [err96];
}
else {
vErrors.push(err96);
}
errors++;
}
if(data43.label === undefined){
const err97 = {instancePath:instancePath+"/options/" + i6+"/choices/" + i7,schemaPath:"#/properties/options/items/properties/choices/items/required",keyword:"required",params:{missingProperty: "label"},message:"must have required property '"+"label"+"'"};
if(vErrors === null){
vErrors = [err97];
}
else {
vErrors.push(err97);
}
errors++;
}
for(const key9 in data43){
if(!((key9 === "value") || (key9 === "label"))){
const err98 = {instancePath:instancePath+"/options/" + i6+"/choices/" + i7,schemaPath:"#/properties/options/items/properties/choices/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key9},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err98];
}
else {
vErrors.push(err98);
}
errors++;
}
}
if(data43.value !== undefined){
let data44 = data43.value;
if(!(((typeof data44 == "number") && (!(data44 % 1) && !isNaN(data44))) && (isFinite(data44)))){
const err99 = {instancePath:instancePath+"/options/" + i6+"/choices/" + i7+"/value",schemaPath:"#/properties/options/items/properties/choices/items/properties/value/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err99];
}
else {
vErrors.push(err99);
}
errors++;
}
}
if(data43.label !== undefined){
let data45 = data43.label;
if(typeof data45 === "string"){
if(func2(data45) > 40){
const err100 = {instancePath:instancePath+"/options/" + i6+"/choices/" + i7+"/label",schemaPath:"#/$defs/label/maxLength",keyword:"maxLength",params:{limit: 40},message:"must NOT have more than 40 characters"};
if(vErrors === null){
vErrors = [err100];
}
else {
vErrors.push(err100);
}
errors++;
}
if(func2(data45) < 1){
const err101 = {instancePath:instancePath+"/options/" + i6+"/choices/" + i7+"/label",schemaPath:"#/$defs/label/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err101];
}
else {
vErrors.push(err101);
}
errors++;
}
}
else {
const err102 = {instancePath:instancePath+"/options/" + i6+"/choices/" + i7+"/label",schemaPath:"#/$defs/label/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err102];
}
else {
vErrors.push(err102);
}
errors++;
}
}
}
else {
const err103 = {instancePath:instancePath+"/options/" + i6+"/choices/" + i7,schemaPath:"#/properties/options/items/properties/choices/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err103];
}
else {
vErrors.push(err103);
}
errors++;
}
}
}
else {
const err104 = {instancePath:instancePath+"/options/" + i6+"/choices",schemaPath:"#/properties/options/items/properties/choices/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err104];
}
else {
vErrors.push(err104);
}
errors++;
}
}
}
else {
const err105 = {instancePath:instancePath+"/options/" + i6,schemaPath:"#/properties/options/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err105];
}
else {
vErrors.push(err105);
}
errors++;
}
}
}
else {
const err106 = {instancePath:instancePath+"/options",schemaPath:"#/properties/options/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err106];
}
else {
vErrors.push(err106);
}
errors++;
}
}
if(data.net !== undefined){
let data46 = data.net;
if(data46 && typeof data46 == "object" && !Array.isArray(data46)){
for(const key10 in data46){
if(!((key10 === "players") || (key10 === "model"))){
const err107 = {instancePath:instancePath+"/net",schemaPath:"#/properties/net/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key10},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err107];
}
else {
vErrors.push(err107);
}
errors++;
}
}
if(data46.players !== undefined){
let data47 = data46.players;
if(!(((typeof data47 == "number") && (!(data47 % 1) && !isNaN(data47))) && (isFinite(data47)))){
const err108 = {instancePath:instancePath+"/net/players",schemaPath:"#/properties/net/properties/players/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err108];
}
else {
vErrors.push(err108);
}
errors++;
}
if((typeof data47 == "number") && (isFinite(data47))){
if(data47 > 4 || isNaN(data47)){
const err109 = {instancePath:instancePath+"/net/players",schemaPath:"#/properties/net/properties/players/maximum",keyword:"maximum",params:{comparison: "<=", limit: 4},message:"must be <= 4"};
if(vErrors === null){
vErrors = [err109];
}
else {
vErrors.push(err109);
}
errors++;
}
if(data47 < 1 || isNaN(data47)){
const err110 = {instancePath:instancePath+"/net/players",schemaPath:"#/properties/net/properties/players/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err110];
}
else {
vErrors.push(err110);
}
errors++;
}
}
}
if(data46.model !== undefined){
let data48 = data46.model;
if(!((data48 === "lockstep") || (data48 === "link"))){
const err111 = {instancePath:instancePath+"/net/model",schemaPath:"#/properties/net/properties/model/enum",keyword:"enum",params:{allowedValues: schema31.properties.net.properties.model.enum},message:"must be equal to one of the allowed values"};
if(vErrors === null){
vErrors = [err111];
}
else {
vErrors.push(err111);
}
errors++;
}
}
}
else {
const err112 = {instancePath:instancePath+"/net",schemaPath:"#/properties/net/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err112];
}
else {
vErrors.push(err112);
}
errors++;
}
}
if(data.shares !== undefined){
let data49 = data.shares;
if(data49 && typeof data49 == "object" && !Array.isArray(data49)){
for(const key11 in data49){
if(!((key11 === "provides") || (key11 === "consumes"))){
const err113 = {instancePath:instancePath+"/shares",schemaPath:"#/properties/shares/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key11},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err113];
}
else {
vErrors.push(err113);
}
errors++;
}
}
if(data49.provides !== undefined){
let data50 = data49.provides;
if(Array.isArray(data50)){
if(data50.length > 16){
const err114 = {instancePath:instancePath+"/shares/provides",schemaPath:"#/properties/shares/properties/provides/maxItems",keyword:"maxItems",params:{limit: 16},message:"must NOT have more than 16 items"};
if(vErrors === null){
vErrors = [err114];
}
else {
vErrors.push(err114);
}
errors++;
}
const len6 = data50.length;
for(let i8=0; i8<len6; i8++){
let data51 = data50[i8];
if(typeof data51 === "string"){
if(!pattern4.test(data51)){
const err115 = {instancePath:instancePath+"/shares/provides/" + i8,schemaPath:"#/$defs/shareKind/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]{0,63}$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]{0,63}$"+"\""};
if(vErrors === null){
vErrors = [err115];
}
else {
vErrors.push(err115);
}
errors++;
}
}
else {
const err116 = {instancePath:instancePath+"/shares/provides/" + i8,schemaPath:"#/$defs/shareKind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err116];
}
else {
vErrors.push(err116);
}
errors++;
}
}
}
else {
const err117 = {instancePath:instancePath+"/shares/provides",schemaPath:"#/properties/shares/properties/provides/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err117];
}
else {
vErrors.push(err117);
}
errors++;
}
}
if(data49.consumes !== undefined){
let data52 = data49.consumes;
if(Array.isArray(data52)){
if(data52.length > 16){
const err118 = {instancePath:instancePath+"/shares/consumes",schemaPath:"#/properties/shares/properties/consumes/maxItems",keyword:"maxItems",params:{limit: 16},message:"must NOT have more than 16 items"};
if(vErrors === null){
vErrors = [err118];
}
else {
vErrors.push(err118);
}
errors++;
}
const len7 = data52.length;
for(let i9=0; i9<len7; i9++){
let data53 = data52[i9];
if(typeof data53 === "string"){
if(!pattern4.test(data53)){
const err119 = {instancePath:instancePath+"/shares/consumes/" + i9,schemaPath:"#/$defs/shareKind/pattern",keyword:"pattern",params:{pattern: "^[a-z0-9][a-z0-9-]{0,63}$"},message:"must match pattern \""+"^[a-z0-9][a-z0-9-]{0,63}$"+"\""};
if(vErrors === null){
vErrors = [err119];
}
else {
vErrors.push(err119);
}
errors++;
}
}
else {
const err120 = {instancePath:instancePath+"/shares/consumes/" + i9,schemaPath:"#/$defs/shareKind/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err120];
}
else {
vErrors.push(err120);
}
errors++;
}
}
}
else {
const err121 = {instancePath:instancePath+"/shares/consumes",schemaPath:"#/properties/shares/properties/consumes/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err121];
}
else {
vErrors.push(err121);
}
errors++;
}
}
}
else {
const err122 = {instancePath:instancePath+"/shares",schemaPath:"#/properties/shares/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err122];
}
else {
vErrors.push(err122);
}
errors++;
}
}
if(data.license !== undefined){
let data54 = data.license;
if(typeof data54 === "string"){
if(func2(data54) > 200){
const err123 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/maxLength",keyword:"maxLength",params:{limit: 200},message:"must NOT have more than 200 characters"};
if(vErrors === null){
vErrors = [err123];
}
else {
vErrors.push(err123);
}
errors++;
}
}
else {
const err124 = {instancePath:instancePath+"/license",schemaPath:"#/properties/license/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err124];
}
else {
vErrors.push(err124);
}
errors++;
}
}
if(data.source !== undefined){
let data55 = data.source;
if(typeof data55 === "string"){
if(func2(data55) > 300){
const err125 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/maxLength",keyword:"maxLength",params:{limit: 300},message:"must NOT have more than 300 characters"};
if(vErrors === null){
vErrors = [err125];
}
else {
vErrors.push(err125);
}
errors++;
}
if(!pattern12.test(data55)){
const err126 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/pattern",keyword:"pattern",params:{pattern: "^https://"},message:"must match pattern \""+"^https://"+"\""};
if(vErrors === null){
vErrors = [err126];
}
else {
vErrors.push(err126);
}
errors++;
}
}
else {
const err127 = {instancePath:instancePath+"/source",schemaPath:"#/properties/source/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err127];
}
else {
vErrors.push(err127);
}
errors++;
}
}
if(data.fileInputs !== undefined){
let data56 = data.fileInputs;
if(Array.isArray(data56)){
if(data56.length > 8){
const err128 = {instancePath:instancePath+"/fileInputs",schemaPath:"#/properties/fileInputs/maxItems",keyword:"maxItems",params:{limit: 8},message:"must NOT have more than 8 items"};
if(vErrors === null){
vErrors = [err128];
}
else {
vErrors.push(err128);
}
errors++;
}
const len8 = data56.length;
for(let i10=0; i10<len8; i10++){
let data57 = data56[i10];
if(data57 && typeof data57 == "object" && !Array.isArray(data57)){
if(data57.id === undefined){
const err129 = {instancePath:instancePath+"/fileInputs/" + i10,schemaPath:"#/properties/fileInputs/items/required",keyword:"required",params:{missingProperty: "id"},message:"must have required property '"+"id"+"'"};
if(vErrors === null){
vErrors = [err129];
}
else {
vErrors.push(err129);
}
errors++;
}
if(data57.label === undefined){
const err130 = {instancePath:instancePath+"/fileInputs/" + i10,schemaPath:"#/properties/fileInputs/items/required",keyword:"required",params:{missingProperty: "label"},message:"must have required property '"+"label"+"'"};
if(vErrors === null){
vErrors = [err130];
}
else {
vErrors.push(err130);
}
errors++;
}
if(data57.accept === undefined){
const err131 = {instancePath:instancePath+"/fileInputs/" + i10,schemaPath:"#/properties/fileInputs/items/required",keyword:"required",params:{missingProperty: "accept"},message:"must have required property '"+"accept"+"'"};
if(vErrors === null){
vErrors = [err131];
}
else {
vErrors.push(err131);
}
errors++;
}
for(const key12 in data57){
if(!((((key12 === "id") || (key12 === "label")) || (key12 === "accept")) || (key12 === "maxSize"))){
const err132 = {instancePath:instancePath+"/fileInputs/" + i10,schemaPath:"#/properties/fileInputs/items/additionalProperties",keyword:"additionalProperties",params:{additionalProperty: key12},message:"must NOT have additional properties"};
if(vErrors === null){
vErrors = [err132];
}
else {
vErrors.push(err132);
}
errors++;
}
}
if(data57.id !== undefined){
let data58 = data57.id;
if(!(((typeof data58 == "number") && (!(data58 % 1) && !isNaN(data58))) && (isFinite(data58)))){
const err133 = {instancePath:instancePath+"/fileInputs/" + i10+"/id",schemaPath:"#/properties/fileInputs/items/properties/id/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err133];
}
else {
vErrors.push(err133);
}
errors++;
}
if((typeof data58 == "number") && (isFinite(data58))){
if(data58 > 255 || isNaN(data58)){
const err134 = {instancePath:instancePath+"/fileInputs/" + i10+"/id",schemaPath:"#/properties/fileInputs/items/properties/id/maximum",keyword:"maximum",params:{comparison: "<=", limit: 255},message:"must be <= 255"};
if(vErrors === null){
vErrors = [err134];
}
else {
vErrors.push(err134);
}
errors++;
}
if(data58 < 1 || isNaN(data58)){
const err135 = {instancePath:instancePath+"/fileInputs/" + i10+"/id",schemaPath:"#/properties/fileInputs/items/properties/id/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err135];
}
else {
vErrors.push(err135);
}
errors++;
}
}
}
if(data57.label !== undefined){
let data59 = data57.label;
if(typeof data59 === "string"){
if(func2(data59) > 40){
const err136 = {instancePath:instancePath+"/fileInputs/" + i10+"/label",schemaPath:"#/$defs/label/maxLength",keyword:"maxLength",params:{limit: 40},message:"must NOT have more than 40 characters"};
if(vErrors === null){
vErrors = [err136];
}
else {
vErrors.push(err136);
}
errors++;
}
if(func2(data59) < 1){
const err137 = {instancePath:instancePath+"/fileInputs/" + i10+"/label",schemaPath:"#/$defs/label/minLength",keyword:"minLength",params:{limit: 1},message:"must NOT have fewer than 1 characters"};
if(vErrors === null){
vErrors = [err137];
}
else {
vErrors.push(err137);
}
errors++;
}
}
else {
const err138 = {instancePath:instancePath+"/fileInputs/" + i10+"/label",schemaPath:"#/$defs/label/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err138];
}
else {
vErrors.push(err138);
}
errors++;
}
}
if(data57.accept !== undefined){
let data60 = data57.accept;
if(Array.isArray(data60)){
if(data60.length > 8){
const err139 = {instancePath:instancePath+"/fileInputs/" + i10+"/accept",schemaPath:"#/properties/fileInputs/items/properties/accept/maxItems",keyword:"maxItems",params:{limit: 8},message:"must NOT have more than 8 items"};
if(vErrors === null){
vErrors = [err139];
}
else {
vErrors.push(err139);
}
errors++;
}
if(data60.length < 1){
const err140 = {instancePath:instancePath+"/fileInputs/" + i10+"/accept",schemaPath:"#/properties/fileInputs/items/properties/accept/minItems",keyword:"minItems",params:{limit: 1},message:"must NOT have fewer than 1 items"};
if(vErrors === null){
vErrors = [err140];
}
else {
vErrors.push(err140);
}
errors++;
}
const len9 = data60.length;
for(let i11=0; i11<len9; i11++){
let data61 = data60[i11];
if(typeof data61 === "string"){
if(!pattern5.test(data61)){
const err141 = {instancePath:instancePath+"/fileInputs/" + i10+"/accept/" + i11,schemaPath:"#/properties/fileInputs/items/properties/accept/items/pattern",keyword:"pattern",params:{pattern: "^\\.[a-z0-9]{1,8}$"},message:"must match pattern \""+"^\\.[a-z0-9]{1,8}$"+"\""};
if(vErrors === null){
vErrors = [err141];
}
else {
vErrors.push(err141);
}
errors++;
}
}
else {
const err142 = {instancePath:instancePath+"/fileInputs/" + i10+"/accept/" + i11,schemaPath:"#/properties/fileInputs/items/properties/accept/items/type",keyword:"type",params:{type: "string"},message:"must be string"};
if(vErrors === null){
vErrors = [err142];
}
else {
vErrors.push(err142);
}
errors++;
}
}
let i12 = data60.length;
let j2;
if(i12 > 1){
const indices1 = {};
for(;i12--;){
let item1 = data60[i12];
if(typeof item1 !== "string"){
continue;
}
if(typeof indices1[item1] == "number"){
j2 = indices1[item1];
const err143 = {instancePath:instancePath+"/fileInputs/" + i10+"/accept",schemaPath:"#/properties/fileInputs/items/properties/accept/uniqueItems",keyword:"uniqueItems",params:{i: i12, j: j2},message:"must NOT have duplicate items (items ## "+j2+" and "+i12+" are identical)"};
if(vErrors === null){
vErrors = [err143];
}
else {
vErrors.push(err143);
}
errors++;
break;
}
indices1[item1] = i12;
}
}
}
else {
const err144 = {instancePath:instancePath+"/fileInputs/" + i10+"/accept",schemaPath:"#/properties/fileInputs/items/properties/accept/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err144];
}
else {
vErrors.push(err144);
}
errors++;
}
}
if(data57.maxSize !== undefined){
let data62 = data57.maxSize;
if(!(((typeof data62 == "number") && (!(data62 % 1) && !isNaN(data62))) && (isFinite(data62)))){
const err145 = {instancePath:instancePath+"/fileInputs/" + i10+"/maxSize",schemaPath:"#/properties/fileInputs/items/properties/maxSize/type",keyword:"type",params:{type: "integer"},message:"must be integer"};
if(vErrors === null){
vErrors = [err145];
}
else {
vErrors.push(err145);
}
errors++;
}
if((typeof data62 == "number") && (isFinite(data62))){
if(data62 > 67108864 || isNaN(data62)){
const err146 = {instancePath:instancePath+"/fileInputs/" + i10+"/maxSize",schemaPath:"#/properties/fileInputs/items/properties/maxSize/maximum",keyword:"maximum",params:{comparison: "<=", limit: 67108864},message:"must be <= 67108864"};
if(vErrors === null){
vErrors = [err146];
}
else {
vErrors.push(err146);
}
errors++;
}
if(data62 < 1 || isNaN(data62)){
const err147 = {instancePath:instancePath+"/fileInputs/" + i10+"/maxSize",schemaPath:"#/properties/fileInputs/items/properties/maxSize/minimum",keyword:"minimum",params:{comparison: ">=", limit: 1},message:"must be >= 1"};
if(vErrors === null){
vErrors = [err147];
}
else {
vErrors.push(err147);
}
errors++;
}
}
}
}
else {
const err148 = {instancePath:instancePath+"/fileInputs/" + i10,schemaPath:"#/properties/fileInputs/items/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err148];
}
else {
vErrors.push(err148);
}
errors++;
}
}
}
else {
const err149 = {instancePath:instancePath+"/fileInputs",schemaPath:"#/properties/fileInputs/type",keyword:"type",params:{type: "array"},message:"must be array"};
if(vErrors === null){
vErrors = [err149];
}
else {
vErrors.push(err149);
}
errors++;
}
}
}
else {
const err150 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object"};
if(vErrors === null){
vErrors = [err150];
}
else {
vErrors.push(err150);
}
errors++;
}
validate20.errors = vErrors;
return errors === 0;
}
validate20.evaluated = {"props":true,"dynamicProps":false,"dynamicItems":false};
